export const phoneNumberRegex =
  /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

// export const bdPhoneNumberValidation = /^(?:(?:\+|00)88|01)?(?:\d{11}|\d{13})$/gm


// update regex for verify all number including telephone
export const bdPhoneNumberValidation = /(?:\+?88)?\s?01[2-9]\d{8}|(?:\+?88)?\s?\d{1,4}[-.\s]?\d{6,8}/;
